<script lang="ts">
import Vue from 'vue';
import Button from '@/components/ui/Button.vue';
import Card from '@/components/ui/Card.vue';

export default Vue.extend({
  name: 'MainCard',
  components: { Button, Card },
  props: {
    organization: Object,
  }
});
</script>

<template>
<div>
    <Card>
        <template v-slot:title>
            <div class="w-100 d-flex justify-content-between">
                <div>
                    {{ organization.name }}
                </div>
                <div>
                    <img width="159" height="33" src="~@/assets/images/banks/img.png">
                </div>
            </div>
        </template>

        <div class="mb-8">
            <div class="flex-wrapper">
                <div>
                    {{ organization.total_regions_count }} дирекцій
                </div>
                <div>{{ organization.total_branches_count }} відділень</div>
            </div>
            <div class="mt-4">
                <router-link tag="div" class="cursor-pointer" :to="{name: 'organizations.managers', params: {organizationId: organization.id}}">
                    {{ organization.total_users_count }} менеджерів
                </router-link>
            </div>
        </div>
        <div class="footer">
            <router-link :to="{name: 'regions', params: {organizationId: organization.id}}" class="footer-button">
                <Button>Перейти до структури</Button>
            </router-link>
            <router-link :to="{name: 'organizations.tariff-settings', params: {organizationId: organization.id}}" class="footer-button">
              <Button>Налаштувати тарифи</Button>
            </router-link>
        </div>
    </Card>
</div>
</template>

<style scoped lang="scss">
.flex-wrapper {
    display: flex;
    gap: 16px;
}

.footer {
    /* Frame 1000005958 */

    /* Auto layout */
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    padding: 0;
    gap: 8px;

    flex: none;
    order: 1;
    flex-grow: 0;
}

.mb-8 {
    margin-bottom: 2rem;
}

@media (max-width: 550px) {
    .footer {
        flex-direction: column;

        &-button {
            width: 100%;
        }
    }
}
</style>
